import { Launch } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import moment from 'moment'
import React from 'react'
import Colors from 'utils/Colors'

const buildActions = (value) => {
  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <Tooltip title="Visualizar Respostas do formulário">
        <IconButton onClick={() => value.viewAction(value.uuid)}>
          <Launch />
        </IconButton>
      </Tooltip>
    </div>
  )
}

export const columns = [
  {
    name: 'owner_cpf',
    label: 'CPF',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'owner_name',
    label: 'Nome',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'owner_email',
    label: 'Email',
    options: {
      filter: false,
      sort: false,
    },
  },
  {
    name: 'created',
    label: 'Criado em',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return moment(value).format('DD/MM/YYYY')
      },
    },
  },

  {
    name: 'expires_at',
    label: 'Prazo Final',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => {
        return moment(value).format('DD/MM/YYYY')
      },
    },
  },

  {
    name: 'filled',
    label: 'Status',
    options: {
      filter: true,
      filterType: 'dropdown',
      filterOptions: {
      names: ['Pendentes', 'Concluídos'],
    },
      sort: false,
      customBodyRender: (value) => {
        return value ?  <b style={{ color: Colors.green }}>Concluído</b> : <b style={{ color: Colors.warning }}>Pendente</b>
      },
    },
  },

  {
    name: 'actions',
    label: 'Detalhes',
    options: {
      filter: false,
      sort: false,
      download: false,
      customBodyRender: (value) => buildActions(value),
    },
  },
]
